import React from 'react';
import {
  Container,
  VStack,
  Heading,
  Text,
  Box,
  useColorModeValue,
  Divider,
} from '@chakra-ui/react';

const PrivacyPolicy: React.FC = () => {
  const bg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.900', 'white');
  const secondaryColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Container maxW="4xl" py={8}>
        <VStack spacing={6} align="stretch" bg={bg} p={8} borderRadius="lg">
          <Heading size="xl" color={textColor}>
            Privacy Policy
          </Heading>
          <Text color={secondaryColor} fontSize="sm">
            Last updated: {new Date().toLocaleDateString()}
          </Text>

          <Divider />

          <VStack spacing={6} align="stretch">
            <Box>
              <Heading size="md" mb={3} color={textColor}>
                1. Information We Collect
              </Heading>
              <Text color={secondaryColor}>
                We collect information that you provide directly to us, including:
              </Text>
              <Box as="ul" mt={2} pl={6} color={secondaryColor}>
                <li>Account information (name, email, username)</li>
                <li>Content you upload (videos, images, descriptions)</li>
                <li>Payment information (processed securely through Stripe)</li>
                <li>Usage data and analytics</li>
              </Box>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                2. How We Use Your Information
              </Heading>
              <Text color={secondaryColor}>
                We use the information we collect to:
              </Text>
              <Box as="ul" mt={2} pl={6} color={secondaryColor}>
                <li>Provide, maintain, and improve our services</li>
                <li>Process payments and subscriptions</li>
                <li>Send you technical notices and support messages</li>
                <li>Respond to your comments and questions</li>
                <li>Monitor and analyze usage patterns</li>
              </Box>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                3. Data Storage and Security
              </Heading>
              <Text color={secondaryColor}>
                Your data is stored securely using Firebase (Google Cloud Platform).
                We implement appropriate technical and organizational measures to protect
                your personal information against unauthorized access, alteration, disclosure, or destruction.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                4. Cookies and Tracking
              </Heading>
              <Text color={secondaryColor}>
                We use cookies and similar tracking technologies to track activity on our
                platform and hold certain information. You can instruct your browser to
                refuse all cookies or to indicate when a cookie is being sent.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                5. Your Rights (GDPR)
              </Heading>
              <Text color={secondaryColor} mb={2}>
                If you are located in the European Economic Area (EEA), you have certain
                data protection rights:
              </Text>
              <Box as="ul" mt={2} pl={6} color={secondaryColor}>
                <li>Right to access your personal data</li>
                <li>Right to rectify inaccurate data</li>
                <li>Right to erasure ("right to be forgotten")</li>
                <li>Right to restrict processing</li>
                <li>Right to data portability</li>
                <li>Right to object to processing</li>
              </Box>
              <Text color={secondaryColor} mt={2}>
                To exercise these rights, please contact us or use the data export/deletion
                features in your account settings.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                6. Data Retention
              </Heading>
              <Text color={secondaryColor}>
                We retain your personal information for as long as necessary to provide
                our services and comply with legal obligations. You can request deletion
                of your data at any time through your account settings.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                7. Third-Party Services
              </Heading>
              <Text color={secondaryColor}>
                We use third-party services including Firebase (Google), Stripe for payments,
                and Google AdSense for advertising. These services have their own privacy
                policies governing the use of your information.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                8. Children's Privacy
              </Heading>
              <Text color={secondaryColor}>
                Our service is not intended for children under 13 years of age. We do not
                knowingly collect personal information from children under 13. If you are
                a parent or guardian and believe your child has provided us with personal
                information, please contact us.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                9. Changes to This Policy
              </Heading>
              <Text color={secondaryColor}>
                We may update this Privacy Policy from time to time. We will notify you
                of any changes by posting the new Privacy Policy on this page and updating
                the "Last updated" date.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                10. Contact Us
              </Heading>
              <Text color={secondaryColor}>
                If you have any questions about this Privacy Policy, please contact us
                through the support channels available on our platform.
              </Text>
            </Box>
          </VStack>
        </VStack>
      </Container>
  );
};

export default PrivacyPolicy;

